import { useSecureGraphqlQuery } from '@psyomics/ui-common';

import { GetReportDataDocument, GetReportDataQuery, GetReportDataQueryVariables } from '../generated/report';

type ErrorType = 'ReportNotFound' | 'ReferralCancelled' | 'InviteExpired' | 'ReferralPending';

const useReportQuery = ({ referralId, referralSessionId }: { referralId: string; referralSessionId?: string }) => {
  const [{ data, errorMessage, fetching }] = useSecureGraphqlQuery<
    GetReportDataQuery,
    GetReportDataQueryVariables,
    ErrorType
  >(
    {
      query: GetReportDataDocument,
      variables: {
        input: {
          referralId,
          referralSessionId,
        },
      },
    },
    ['ReportNotFound', 'ReferralCancelled', 'InviteExpired', 'ReferralPending']
  );
  return { data, errorMessage, fetching };
};

export type { ErrorType };
export { useReportQuery };
